import { SystemResponse } from '@kcftech/prometheus-client';
import { QueryObserverResult, skipToken, useQuery } from '@tanstack/react-query';
import { dayMs, minuteMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export type UseSystemOptions = Readonly<{
    /**
     * If the query should be executed (defaults to `true`).
     */
    executeQuery?: boolean;
}>;

/**
 * Loads the system for the supplied system id.  If a location id is supplied
 * the system must belong to that location or undefined will be returned.
 *
 * @param systemId The system to load.
 * @param locationId Optional location check for the system.
 * @param executeQuery If the query should be executed.
 */
export function useSystem(
    systemId: string | null | undefined,
    options?: UseSystemOptions,
): QueryObserverResult<SystemResponse, Partial<Error>> {
    const executeQuery = options?.executeQuery ?? true;

    return useQuery({
        queryKey: ['get-system', systemId],

        queryFn:
            !executeQuery || !systemId
                ? skipToken
                : () => sdClient.getSystem({ systemId }),

        gcTime: 2 * dayMs,
        staleTime: 30 * minuteMs,
    });
}

export function invalidateSystemQuery(systemId: string): void {
    queryClient.invalidateQueries({ queryKey: ['get-system', systemId] });
}
